exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = require('stream');
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');
if (!process.browser && process.env.READABLE_STREAM === 'disable') {
  module.exports = require('stream');
}



/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/readable.js
 ** module id = 998
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/readable.js
 ** module id = 998
 ** module chunks = 1
 **/